// extracted by mini-css-extract-plugin
export default {"wrapper":"EventCard_wrapper__yG6+I","eventTimes":"EventCard_eventTimes__oBgbl"};